"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const IconContainer_1 = __importStar(require("../IconContainer"));
const StyledPath = styled_components_1.default.path `
  fill: ${({ theme }) => theme.palette.gray[0]};
`;
const HelpIcon = ({ size = IconContainer_1.DEFAULT_ICON_SIZE, ...rest }) => ((0, jsx_runtime_1.jsxs)(IconContainer_1.StyledSvg, { fill: "none", height: size, viewBox: "0 0 24 24", width: size, xmlns: "http://www.w3.org/2000/svg", ...rest, children: [(0, jsx_runtime_1.jsx)(StyledPath, { clipRule: "evenodd", d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z", fillRule: "evenodd" }), (0, jsx_runtime_1.jsx)("path", { d: "M11.006 14.126c0-.595.074-1.07.222-1.423.148-.353.438-.74.873-1.161.438-.426.716-.728.832-.907.18-.273.269-.568.269-.886 0-.42-.105-.74-.316-.96-.206-.224-.51-.336-.913-.336-.385 0-.696.11-.933.33-.233.214-.35.507-.35.879H9.06c.008-.793.277-1.42.805-1.88.533-.461 1.235-.692 2.108-.692.9 0 1.6.229 2.102.685.505.457.758 1.094.758 1.914 0 .73-.34 1.447-1.02 2.155l-.826.812c-.296.336-.448.826-.457 1.47h-1.524zm-.114 2.088c0-.264.083-.476.249-.637.165-.166.389-.249.671-.249.287 0 .513.085.678.255a.855.855 0 01.248.631.85.85 0 01-.241.618c-.161.166-.39.248-.685.248-.295 0-.524-.082-.685-.248a.864.864 0 01-.235-.618z" })] }));
exports.default = (0, IconContainer_1.default)(HelpIcon);
//# sourceMappingURL=index.js.map